<template>
  <div class="home-container">
    <div id="top"></div>
    <!-- 导航栏 -->
    <nav class="nav-container">
      <div class="nav-content">
        <div class="nav-left">
          <div class="logo">
            <img class="logo-img" @click="scrollToSection('top')" src="@/assets/img/logo.png" alt="logo" />
            <!-- <span class="logo-text" @click="scrollToSection('top')">logo</span> -->
          </div>
          <div class="nav-links">
            <a v-for="(item, index) in translations[locale].navItems" 
               :key="index" 
               class="nav-link">
              {{ item.text }}
            </a>
          </div>
          <button class="mobile-menu-btn" @click="toggleMobileMenu">
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
        <div class="nav-right">
          <div class="language-switch" @click="toggleLanguage">
            <img src="@/assets/img/icon_ts.png" alt="language" />
            <span>{{ locale === 'zh' ? '中文' : 'English' }}</span>
          </div>
          <button class="start-btn">{{ translations[locale].startButton }}</button>
        </div>
      </div>
      <!-- 移动端菜单 -->
      <div class="mobile-menu" :class="{ 'is-open': isMobileMenuOpen }">
        <a v-for="(item, index) in translations[locale].navItems" 
           :key="index" 
           class="mobile-nav-link"
           :href="item.url">
          {{ item.text }}
        </a>
      </div>
    </nav>
    <img class="banner-img" src="@/assets/img/banner.png" />

    <!-- 主要内容区域 -->
    <main class="main-content">
      <!-- 建构去中心化 -->
      <div id="home">
        <HeroSection />
      </div>
      <div id="vision">
        <VisionSection />
      </div>
      <!-- 生态系统 -->
      <div id="token">
        <TokenSection />
      </div>
      <!-- 代币经济模型 -->
      <div id="economy">
        <EconomySection />
      </div>
      <!-- 发展路线图 -->
      <div id="resonance">
        <ResonanceSection />
      </div>
      <!-- 技术团队 -->
      <div id="tech">
        <TechSection />
      </div>
    </main>

    <FooterSection />
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useStore } from '@/stores/language'
import HeroSection from '@/views/home/components/HeroSection.vue'
import VisionSection from '@/views/home/components/VisionSection.vue'
import TokenSection from '@/views/home/components/TokenSection.vue'
import EconomySection from '@/views/home/components/EconomySection.vue'
import ResonanceSection from '@/views/home/components/ResonanceSection.vue'
import TechSection from '@/views/home/components/TechSection.vue'
import FooterSection from '@/views/home/components/FooterSection.vue'

const store = useStore()
const locale = computed(() => store.locale)
const isMobileMenuOpen = ref(false)

const translations = {
  zh: {
    navItems: [
      { text: '首頁', url: '' },
      { text: '產品', url: '' },
      { text: '解決方案', url: '' },
      { text: '生態', url: '' },
      { text: '關於', url: '' }
    ],
    startButton: '開始使用'
  },
  en: {
    navItems: [
      { text: 'Home', url: '' },
      { text: 'Products', url: '' },
      { text: 'Solutions', url: '' },
      { text: 'Ecosystem', url: '' },
      { text: 'About', url: '' }
    ],
    startButton: 'Get Started'
  }
}

function scrollToSection(sectionId) {
  const element = document.getElementById(sectionId);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth' });
  }
}

const toggleLanguage = () => {
  store.setLocale(locale.value === 'zh' ? 'en' : 'zh')
}

const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value
}
</script>

<style lang="scss" scoped>
.home-container {
  width: 100%;
  background-color: #0F172A;
  overflow-x: hidden;
}

.nav-container {
  width: 100%;
  height: 81px;
  background: #FFFFFF;
  border-bottom: 1px solid #F3F4F6;
  position: fixed;
  top: 0;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.nav-content {
  max-width: 1440px;
  height: 80px;
  margin: 0 auto;
  padding: 0 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav-left {
  display: flex;
  align-items: center;
  gap: 4rem;
}

.logo-text {
  color: #6366F1;
  font-size: 2rem;
  font-family: Pacifico;
  font-weight: 400;
}
.logo-img{
  width: 50px;
}

.nav-links {
  display: flex;
  gap: 2rem;
}

.nav-link {
  color: #111827;
  font-size: 1rem;
  font-family: Roboto;
  text-decoration: none;
  transition: color 0.3s ease;

  &:hover {
    color: #6366F1;
  }

  &.router-link-active {
    color: #6366F1;
    font-weight: 500;
  }
}

.nav-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.language-switch {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  cursor: pointer;
  border-radius: 0.25rem;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #F3F4F6;
  }

  span {
    color: #4B5563;
    font-size: 1rem;
  }
}

.start-btn {
  padding: 0.5rem 1.5rem;
  background: #6366F1;
  color: #FFFFFF;
  border: none;
  border-radius: 0.25rem;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: #4F46E5;
    transform: translateY(-1px);
  }
}

.mobile-menu-btn {
  display: none;
  flex-direction: column;
  gap: 6px;
  padding: 4px;
  background: none;
  border: none;
  cursor: pointer;

  span {
    display: block;
    width: 24px;
    height: 2px;
    background-color: #111827;
    transition: all 0.3s ease;
  }
}

.mobile-menu {
  display: none;
  position: absolute;
  top: 81px;
  left: 0;
  width: 100%;
  background: #FFFFFF;
  padding: 1rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transform: translateY(-100%);
  opacity: 0;
  transition: all 0.3s ease;

  &.is-open {
    transform: translateY(0);
    opacity: 1;
    display: block;
  }
}

.mobile-nav-link {
  display: block;
  padding: 1rem;
  color: #111827;
  text-decoration: none;
  font-size: 1rem;
  border-bottom: 1px solid #F3F4F6;
  transition: all 0.3s ease;

  &:hover {
    background-color: #F3F4F6;
    color: #6366F1;
  }

  &:last-child {
    border-bottom: none;
  }
}

.main-content {
  margin-top: 81px;
}

.banner-img {
  width: 100%;
}

// 响应式设计
@media screen and (max-width: 1024px) {
  .nav-content {
    padding: 0 1.5rem;
  }

  .nav-left {
    gap: 2rem;
  }

  .nav-links {
    gap: 1.5rem;
  }
}

@media screen and (max-width: 768px) {
  .nav-content {
    padding: 0 1rem;
  }

  .nav-links {
    display: none;
  }

  .mobile-menu-btn {
    display: flex;
  }

  // .mobile-menu {
  //   display: block;
  // }

  .nav-left {
    gap: 1rem;
  }

  .logo-text {
    font-size: 1.5rem;
  }

  .start-btn {
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
  }
}

@media screen and (max-width: 480px) {
  .nav-content {
    padding: 0 0.75rem;
  }

  .language-switch {
    padding: 0.5rem;

    span {
      display: none;
    }
  }

  .start-btn {
    padding: 0.5rem 0.75rem;
    font-size: 0.75rem;
  }
}

// 深色模式支持
@media (prefers-color-scheme: dark) {
  .nav-container {
    background: #1F2937;
    border-bottom-color: #374151;
  }

  .nav-link {
    color: #E5E7EB;

    &:hover {
      color: #818CF8;
    }
  }

  .language-switch {
    &:hover {
      background-color: #374151;
    }

    span {
      color: #E5E7EB;
    }
  }

  .mobile-menu {
    background: #1F2937;
  }

  .mobile-nav-link {
    color: #E5E7EB;
    border-bottom-color: #374151;

    &:hover {
      background-color: #374151;
      color: #818CF8;
    }
  }
}
</style>
